import { useTranslations } from 'next-intl';
import React, { type ReactNode } from 'react';
import { type PaymentTypes } from '@/server-actions/payment-methods';

type FiatHeaderProps = {
  paymentType?: PaymentTypes;
  backButtonRenderer?: ReactNode;
};

const FiatHeader = ({ paymentType, backButtonRenderer }: FiatHeaderProps) => {
  const t = useTranslations(paymentType);

  return (
    <div className="relative flex items-center justify-start border-b border-[var(--colors-dark-200)] py-2.5 font-bold vt-text-size-bigger">
      {backButtonRenderer}
      <span>{t('fiat-details-header')}</span>
    </div>
  );
};

export default FiatHeader;
